import { useMutation } from '@tanstack/react-query';

import { useToaster } from '@components/toaster';

import { api } from 'api';
import { useInvalidateApplicantsAfterReindex } from 'hooks/use-invalidate-applicants-after-reindex';
import { useStore } from 'models/Provider';

type Props = {
  applicationId: number;
};

export function useUnHireApplication() {
  const { applicationStore, t } = useStore();
  const { showError, showSuccess } = useToaster();

  const invalidateApplicantsAfterReindex = useInvalidateApplicantsAfterReindex();

  return useMutation((props: Props) => api.applications.unHire(props.applicationId), {
    onSuccess: (_, { applicationId }) => {
      showSuccess(t('application.unhire.success'));
      invalidateApplicantsAfterReindex();
      applicationStore.unHire(applicationId);
    },
    onError: () => {
      showError(t('application.unhire.error'));
    },
  });
}
